import { Container, ViewStyleProps } from '@nakedplatform/ui';
import styled from 'styled-components';

export const ChatContainer = styled(Container)<ViewStyleProps>`
  min-width: 100vw;
  align-items: center;
  max-width: 850px;
  min-height: 100svh;
  justify-content: space-between;
  flex-direction: column-reverse !important;
`;

export const ChooseProductChatContainer = styled(Container)<ViewStyleProps>`
  min-width: 80vw;
  align-items: center;
  min-height: 100vh;
  justify-content: space-between;
  padding-bottom: 40px;

  @media (max-width: 40em) {
    min-height: auto;
    justify-content: flex-start;
    padding-bottom: 80px;
  }
`;
